// extracted by mini-css-extract-plugin
export default {"layoutStyle":"layout_layoutStyle__3MEQR","h1":"layout_h1__GWO6X","linkStyle":"layout_linkStyle__hCrvY"};